function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.966,7.561c-2.478,0-4.478,2-4.478,4.477c0,2.479,2,4.479,4.478,4.479c2.479,0,4.478-1.999,4.478-4.479 C16.444,9.561,14.445,7.561,11.966,7.561z M11.966,14.948c-1.601,0-2.91-1.304-2.91-2.911c0-1.604,1.305-2.91,2.91-2.91 c1.606,0,2.912,1.306,2.912,2.91C14.878,13.645,13.567,14.948,11.966,14.948L11.966,14.948z M17.672,7.377 c0,0.581-0.468,1.044-1.045,1.044c-0.58,0-1.045-0.466-1.045-1.044c0-0.577,0.468-1.043,1.045-1.043S17.672,6.801,17.672,7.377z  M20.638,8.438c-0.067-1.398-0.386-2.637-1.411-3.66c-1.021-1.021-2.261-1.339-3.659-1.41c-1.441-0.083-5.764-0.083-7.205,0 C6.967,3.434,5.728,3.754,4.704,4.775c-1.025,1.021-1.341,2.26-1.411,3.658c-0.082,1.443-0.082,5.763,0,7.207 c0.066,1.398,0.386,2.638,1.411,3.658c1.024,1.021,2.26,1.341,3.659,1.411c1.441,0.081,5.764,0.081,7.205,0 c1.398-0.067,2.638-0.386,3.659-1.411c1.021-1.021,1.341-2.26,1.411-3.658C20.719,14.196,20.719,9.879,20.638,8.438L20.638,8.438z  M18.774,17.186c-0.305,0.764-0.894,1.353-1.66,1.66c-1.149,0.457-3.877,0.351-5.148,0.351c-1.27,0-4.002,0.102-5.147-0.351 c-0.764-0.305-1.352-0.892-1.66-1.66c-0.456-1.149-0.351-3.877-0.351-5.148c0-1.269-0.102-4,0.351-5.146 C5.463,6.127,6.052,5.54,6.819,5.23c1.149-0.456,3.877-0.351,5.147-0.351c1.271,0,4.002-0.102,5.148,0.351 c0.764,0.304,1.353,0.892,1.66,1.661c0.455,1.148,0.35,3.876,0.35,5.146C19.124,13.309,19.229,16.039,18.774,17.186z"
});

function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ba3c57cc.svg";
export { ForwardRef as ReactComponent };